










































































import Element from 'element-ui'
import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  getUnitPoints, NewCruiseData, getNew
} from '@/api/heritageCruise/cruiseList'
import { showVaildMsg } from '@/configs/validate'
import { postData } from '@/api/heritageCruise/cruiseList'
import { PopUnitData } from '@/api/heritageUnit/heritageUnit'
import hspGallery from '@/components/upload/gallery.vue'
import PageForm from '@/components/pageLayout/form.vue'
import UnitSearchForm from '@/components/heritageUnit/search/index.vue'

const withPhotosValidator = (otherField: string, msg: string, form: { [key: string]: any }) => {
  return (rule: any, value: any, callback: (error?: Error) => void) => {
    if (value && value.Guid || (form[otherField] && form[otherField].length)) {
      callback()
    } else {
      callback(new Error(msg))
    }
  }
}

export const getNewCruiseFormRules = (form: { [key: string]: any }) => {
  return {
    UnitName: [{ required: true, message: '请选择文保单位', }],
    CruiseType: [{ required: true, message: '请选择类型', trigger: 'change' }],
    Comments: [{ required: true, message: '请输入描述', trigger: 'blur' }],
    CruiseTime: [{ required: true, message: '请输入日期', trigger: 'blur' }]
    // Video: [{ validator: withPhotosValidator('Attachments', '请上传照片或视频', form) }],
  }
}
@Component({
  components: { PageForm, UnitSearchForm, hspGallery }
})
export default class CruiseCheckInDetail extends Vue {
  public expandNames: string[] = ['basic', 'pics']
  public emptyForm: NewCruiseData = {
    CruiseType: '',
    UnitId: 0,
    PointId: 0,
    UnitName: '',
    Comments: '',
    PointName: '',
    AttachType: 0,
    AttachGuid: '',
    CruiseTime: ''
  }
  public points: Array<{ id: number; name: string }> = []
  public form: NewCruiseData = { ...this.emptyForm }
  public loading = false

  public rules: any = getNewCruiseFormRules(this.form)

  // dynamic component
  public $refs!: {
    formCtrl: PageForm
    unitSearchCtrl: UnitSearchForm
  }
  public get commentLabel() {
    return this.form.CruiseType === 'Event'
      ? '事件描述'
      : this.form.CruiseType === 'Cruise'
        ? '巡查描述'
        : '描述'
  }
  public get timeLabel() {
    return this.form.CruiseType === 'Event'
      ? '事件日期'
      : this.form.CruiseType === 'Cruise'
        ? '巡查日期'
        : '日期'
  }
  public onCancel() {
    this.$router.push({ path: '/CruiseList' }).catch((data: any) => {
      console.log(this.$route.path, data)
    })
  }
  public async fetchPoints() {
    try {
      const response = await getUnitPoints(this.form.UnitId)
      if (response.data && response.data.unit && response.data.unit.points) {
        this.points = response.data.unit.points
      }
    } catch (err) {
      console.log(err)
    }
  }
  public mounted() {
    //回调函数
    window.eventBus.$on('submitUnitSearchForm', (data: PopUnitData[]) => {
      this.getUnit(data[0])
    })
  }
  public beforeDestroy() {
    window.eventBus.$off('submitUnitSearchForm')
  }
  //#region 弹窗查询文保单位
  public openUnitSearch() {
    window.eventBus.$emit('openUnitSearchForm')
  }
  //#region 弹窗查询文保单位
  public getUnit(info: PopUnitData) {
    this.form.UnitId = info.UnitId
    this.form.UnitName = info.UnitName
    this.fetchPoints()
    this.$refs.formCtrl.validateField('UnitName')
  }
  public closeUnitSearch() {
    console.log('这里是查询文保单位组件关闭后回传的事件')
  }
  //#endregion
  public created() {
    this.fetchData()
  }
  public fetchData() {
    getNew().then((response: { data: any }) => {
      const data = response.data
      if (data) {
        this.form.AttachType = data.AttachType
        this.form.AttachGuid = data.AttachGuid
        this.setGalleryOpts()
      }
    })
  }
  public setGalleryOpts() {
    let f = this.form
    const opts = {
      referId: 0,
      referType: f.AttachType,
      tempGuid: f.AttachGuid
    }
    //打开弹窗的时候，把附件refer传递给hspGallery控件
    window.eventBus.$emit('demandGallery', opts)
  }
  public onSubmit() {
    this.saveData()
  }
  public async saveData() {
    const data = { ...this.form }
    const response = await postData(data)
    if (response.data && response.data.success) {
      this.$router.push({ path: '/CruiseList' }).catch((data: any) => {
        console.log(this.$route.path, data)
      })
      this.$message({
        message: `创建成功`,
        type: 'success'
      })
    }
  }

  @Watch('$route')
  public onRouteChange(route: any) {
    this.fetchData()
  }
}
